/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PharmacyIndentApi } from '../api/pharmacyindent.api';
import { switchMap, map } from 'rxjs/operators';
import { PharmacyIndentData, PharmacyIndent } from '../../../interfaces/masters/pharmacyindent';

@Injectable()
export class PharmacyIndentService extends PharmacyIndentData {

  constructor(private api: PharmacyIndentApi) {
    super();
  }



  list(url: string): Observable<PharmacyIndent[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PharmacyIndent>{
      return this.api.getById(url);
  }

  create(url: string, data:PharmacyIndent): Observable<PharmacyIndent> {
    return this.api.add(url,data);
  }

  update(url: string, data:PharmacyIndent): Observable<PharmacyIndent> {
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
